import { http } from "@/providers/http";
import { utils } from "@/utils/utils";

/**
 * Ethics complaints, staff side.
 *
 * Complaints are stored in one shared table across CPRS, CFSS and CYAPSS, so
 * the list is the same queue in every portal. Passing `program` narrows it;
 * omitting it returns every program plus complaints that have not been routed
 * to one yet.
 */
export class ComplaintApi {
  private static INSTANCE = new ComplaintApi();

  static get instance() {
    return this.INSTANCE;
  }

  public getComplaintList(filters: any) {
    const filterKeys: string[] = [];
    const keys = Object.keys(filters);
    for (let i = 0; i < keys.length; i++) {
      if (!utils.emptyValues.includes(filters[keys[i]])) {
        const filterKey = `${keys[i]}=${filters[keys[i]]}`;
        filterKeys.push(filterKey);
      }
    }
    const filterStr = filterKeys.join("&");
    const endPoint = `cyapss/complaint/list?${filterStr}`;
    const headers = http.getTokenHeaders();
    return http.get(endPoint, headers).then((response) => {
      return response.data;
    });
  }

  public getComplaint(id: string) {
    const endPoint = `cyapss/complaint`;
    const headers = http.getTokenHeaders();
    return http.get(endPoint, headers, { id }).then((response) => {
      return response.data;
    });
  }

  /**
   * Triage in one call: program, status and comment are applied together in a
   * single transaction, so a complaint can never be left half-updated.
   * Everything but the id is optional.
   */
  public updateComplaint(
    id: string,
    changes: {
      program?: string;
      status?: string;
      comment?: string;
      /** Staff attachments, sent whole: an empty array clears them. */
      reviewerAttachment?: any[];
    }
  ) {
    const endPoint = `cyapss/complaint`;
    const headers = http.getTokenHeaders();
    return http.put(endPoint, headers, { id, ...changes }).then((response) => {
      return response;
    });
  }
}

export const complaintApi = ComplaintApi.instance;
